import React from 'react';
import PropTypes from 'prop-types';

const Angle2Path = ({ fill }) => {
  return (
    <path
      fill={fill}
      d="M5 6C3.343 6 2 7.341 2 8.999v14a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3v-14A2.999 2.999 0 0 0 19 6H5zm3.645 5.616c.591-1.211 1.641-1.817 3.149-1.817 1.193 0 2.141.356 2.846 1.067.706.713 1.057 1.654 1.057 2.827 0 .898-.248 1.697-.746 2.395-.326.463-.863.979-1.609 1.549l-.887.677c-.555.425-.934.732-1.139.922-.205.19-.377.522-.516.773H16v1.99H8c.021-.871.194-1.666.521-2.387.316-.809 1.063-1.666 2.239-2.57 1.022-.787 1.682-1.351 1.983-1.691.461-.53.692-1.111.692-1.742 0-.514-.132-.941-.396-1.281-.265-.341-.644-.511-1.136-.511-.673 0-1.132.27-1.376.812-.14.312-.223.81-.248 1.49H8.125c.036-1.032.21-1.866.52-2.503zm22.237-3.988l-6.627 3.728a.5.5 0 0 0-.255.435v8.416c0 .18.098.347.255.436l6.627 3.727A.75.75 0 0 0 32 23.716V8.281a.751.751 0 0 0-.751-.75.739.739 0 0 0-.367.097z"
    />
  );
};

Angle2Path.propTypes = {
  fill: PropTypes.string,
};

export default Angle2Path;



// WEBPACK FOOTER //
// ./src/icon/svgs/media-playback/angle-2.jsx